export type { AuthenticationClient, UserRecord } from "./authenticationClient.js";
export {
  default as FirebaseAuthenticationClient,
  FirebaseOpaqueLoginToken,
  FirebaseOpaqueIDToken,
} from "./firebaseAuthenticationClient.js";
